import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import reduxStore from './store/redux-store-index';
import initializeTagManager from './core/initialize-TagManager';

import App from './App';

import './styles/main.scss';

initializeTagManager();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <App />
    </Provider>
  </React.StrictMode>,
);
